import React from 'react';
import Dashboard from './Dashboard';
import GroceryManager from './GroceryManager';
import './GroceryPages.css';

const GroceryWholesalePage = () => {
  return (
    <>
      <Dashboard />

      <div className="grocery-page-wrapper grocery-page-wrapper-clean">
        <div className="grocery-page-content-card grocery-page-content-card-clean">
          <GroceryManager mode="wholesale" title="Wholesale Product Panel" />
        </div>
      </div>
    </>
  );
};

export default GroceryWholesalePage;
